import { EntityHistory } from "../../entity/EntityHistory";

export class DtoHistorysPutRes extends EntityHistory {}
